import gql from 'graphql-tag';

export const GET_PROJECTS = gql`
query {
    projects {
      name
      centrals {
        id
        name
      }
    }
}
`;